<template>
    <v-dialog :value="value" max-width="600" persistent scrollable>
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">Novo juiz</h3>
                    <p class="ui-section-description">Para quem ainda não apareceu na captação. A importação passa a ligar os casos novos a este cadastro pelo nome.</p>
                </div>
            </div>
            <div class="ui-card__body">
                <v-row dense>
                    <v-col cols="12" sm="8"><v-text-field v-model="form.name" label="Nome" outlined dense hide-details="auto" autofocus @input="queueSimilar"></v-text-field></v-col>
                    <v-col cols="12" sm="4"><v-text-field v-model="form.tribunal" label="Tribunal (ex.: TJRS)" outlined dense hide-details="auto" @input="queueSimilar"></v-text-field></v-col>
                </v-row>
                <similar-list :items="similar" kind="judge" @open="openJudge" />
                <v-row dense class="mt-1">
                    <v-col cols="12" sm="7"><v-text-field v-model="form.personal_email" label="E-mail" outlined dense hide-details="auto"></v-text-field></v-col>
                    <v-col cols="12" sm="5"><v-text-field v-model="form.personal_phone" label="Telefone" outlined dense hide-details="auto"></v-text-field></v-col>
                    <v-col cols="12" sm="8">
                        <v-autocomplete v-model="form.court_id" :items="courts" item-value="id" :item-text="courtText" label="Vara atual (opcional)" outlined dense hide-details="auto" clearable
                            no-data-text="Nenhuma vara encontrada" :menu-props="{ offsetY: true }"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4"><v-text-field v-model="form.started_at" type="date" label="Na vara desde" outlined dense hide-details="auto" :disabled="!form.court_id"></v-text-field></v-col>
                    <v-col cols="12"><v-textarea v-model="form.profile_notes" label="Perfil (como decide, o que valoriza)" outlined dense rows="2" auto-grow hide-details="auto"></v-textarea></v-col>
                </v-row>
                <p class="ui-small ui-muted mt-2 mb-0">Contatos pessoais são dados pessoais: registre só o necessário para o relacionamento.</p>
            </div>
            <div class="ui-card__footer">
                <v-btn outlined :disabled="saving" @click="close">Cancelar</v-btn>
                <v-btn v-if="$allowed('create')" color="primary" depressed :loading="saving" :disabled="!form.name.trim()" @click="save">Cadastrar</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import SimilarList from "@/components/prospect/bench/SimilarList.vue";
import { notifyError, notifySuccess } from "@/components/prospect/prospect.util";

const EMPTY = () => ({ name: "", tribunal: "", personal_email: "", personal_phone: "", court_id: null, started_at: "", profile_notes: "" });

// Cadastro manual de juiz (Juizes e varas). Avisa os nomes parecidos antes de
// criar, para nao duplicar quem ja veio da captacao.
export default {
    name: "ProspectJudgeFormDialog",

    components: { SimilarList },

    props: {
        value: { type: Boolean, default: false },
        courts: { type: Array, default: () => [] },
    },

    data: () => ({ form: EMPTY(), saving: false, similar: [], timer: null }),

    watch: {
        value(open) {
            if (open) {
                this.form = EMPTY();
                this.similar = [];
            }
        },
    },

    methods: {
        courtText(court) {
            return `${court.name} (${[court.city, court.uf].filter(Boolean).join("/")})`;
        },

        queueSimilar() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.loadSimilar(), 350);
        },

        async loadSimilar() {
            if (this.form.name.trim().length < 3) {
                this.similar = [];
                return;
            }
            try {
                const result = await axios.get("/api/admin/prospect/judges/similar", { params: { name: this.form.name, tribunal: this.form.tribunal || undefined } });
                this.similar = result.data.content;
            } catch (error) {
                this.similar = [];
            }
        },

        openJudge(item) {
            this.close();
            this.$router.push(`/prospeccao/juizes/${item.id}`);
        },

        async save() {
            this.saving = true;
            try {
                const payload = { ...this.form };
                if (!payload.court_id) delete payload.started_at;
                const result = await axios.post("/api/admin/prospect/judges", payload);
                notifySuccess(this, "Juiz cadastrado.");
                this.$emit("saved", result.data.content);
                this.close();
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.saving = false;
            }
        },

        close() {
            this.$emit("input", false);
        },
    },
};
</script>
